/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.datemask.init());


App.datemask = {

  init() {
    return $(document)
      .off('keydown', '.js-datemask', App.datemask.typing)
      .on('keydown', '.js-datemask', App.datemask.typing);
  },


  typing(evt) {
    const {
      key
    } = evt;
    const $el = $(evt.target);
    const val = $el.val();
    const {
      length
    } = val;

    // Bail early for allowed special keys
    if (/backspace|delete|arrow|tab/i.test(key)) { return true; }

    // Allow single-digit day and month, allow hyphen
    if (((key === '/') || (key === '-')) && ((length === 1) || (length === 4))) {
      const first = val.slice(0, -1);
      const last = val.slice(-1);
      $el.val(`${first}0${last}/`);
      return false;
    }

    // Reject if date is finished or non-digit
    if ((length >= 10) || !/\d/.test(key)) { return false; }

    // Add the separator if at appropriate position
    if ((length === 1) || (length === 4)) {
      $el.val(`${val}${key}/`);
      return false;
    }
  }
};
